@if (medewerker$ | async; as medewerker) {
	<div class="dashboard-cijfers">
		<app-filter-bar></app-filter-bar>
		<app-filter-panel
			[defaultFilters]="variant() === DashboardVariant.ACTUEEL ? actueelFilters : historieFilters"
			[allFilters]="allFilters()"
			[leerlingselectie]="false"
			(filterExpressionsChange)="filterExpressions.set($event)"
			endpoint="/cijfers"
			[permanentFilterExpressions]="getDashboardFilters(permanentFilterExpressions, medewerker.medewerker)"
			[overrideDefault]="getSchooljaarFilterOverride(medewerker.schooljaarInfo)"
		></app-filter-panel>
		<section class="dashboard">
			<app-dashboard-header>
				<app-toggle-buttons [options]="varianten" [value]="variant()" (valueChange)="qp.dispatch('variant', $event)"></app-toggle-buttons>
				<app-legenda class="cl-header-utility" [attribute]="['x_cijfer_ov']"></app-legenda>
			</app-dashboard-header>
			@switch (variant()) {
				@case (DashboardVariant.ACTUEEL) {
					<app-card-list
						[config]="this"
						[filters]="filterExpressions()"
						[permanentFilters]="getDashboardFilters(permanentFilterExpressions, medewerker.medewerker)"
						[groups]="actueelGroups"
						[sortHeaders]="actueelSortHeaders"
						[template]="actueelCardTemplate"
						data-exportable
					>
						<ng-template #actueelCardTemplate let-row="row" let-context="context" let-group="group">
							<app-card-cell-header [title]="group['cf_nm_lesgroep']"></app-card-cell-header>
							<app-hbar-partition [data]="generateHbarPartition(row, context)" [axis]="false"></app-hbar-partition>
							<app-card-cell-footer [measures]="generateMeasures(row)"></app-card-cell-footer>
						</ng-template>
					</app-card-list>
				}
				@case (DashboardVariant.HISTORIE) {
					<app-card-list
						[config]="this"
						[filters]="filterExpressions()"
						[permanentFilters]="getDashboardFilters(permanentFilterExpressions, medewerker.medewerker)"
						[groups]="historieGroups"
						[subgroups]="subGroups"
						[sortHeaders]="historieSortHeaders"
						[template]="historieCardTemplate"
						data-exportable
					>
						<ng-template #historieCardTemplate let-row="row" let-context="context" let-group="group">
							<app-card-cell-header [title]="group['cf_fk_lb.lb_nm_leerfase']"></app-card-cell-header>
							<app-vbar-series [yAxis]="yAxis" [partitions]="generateVbarPartitions(row, context)"></app-vbar-series>
						</ng-template>
					</app-card-list>
				}
			}
		</section>
	</div>
}
